import React from 'react';

class TextField extends React.Component {
  render() {
    const {
      label,
      required,
      hint,
      type,
      inputMode,
      value,
      onChange,
      placeholder,
      disabled,
      autoComplete,
      maxLength,
      fieldId,
      error,
    } = this.props;
    const hasError = !!error;

    return (
      <div className="w-full" data-field-id={fieldId || undefined}>
        {label ? (
          <label className="block text-sm font-medium text-[#1F2937] mb-2">
            {label}
            {required ? <span className="text-[#DC2626] ml-1">*</span> : null}
          </label>
        ) : null}
        <input
          type={type || 'text'}
          inputMode={inputMode}
          required={required}
          disabled={disabled}
          autoComplete={autoComplete}
          maxLength={maxLength}
          placeholder={placeholder}
          value={value || ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          aria-invalid={hasError || undefined}
          className="dui-input dui-input-bordered w-full bg-white text-[#1F2937] focus:outline-none focus:ring-2"
          style={{
            borderColor: hasError ? '#DC2626' : '#D1D5DB',
            // The focus ring colour is hinted via inline styles to match
            // the border state (red for errors, brand purple otherwise).
            outlineColor: hasError ? '#DC2626' : '#7C5CFC',
            boxShadow: hasError ? '0 0 0 1px #DC2626' : undefined,
          }}
        />
        {hasError ? (
          <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : hint ? (
          <p className="mt-1 text-xs text-[#6B7280]">{hint}</p>
        ) : null}
      </div>
    );
  }
}

export default TextField;
